import { createFileRoute } from '@tanstack/react-router';
import DialogRedirectPage from 'src/features/plugins/outlook/dialog/page';

export const Route = createFileRoute('/plugins/outlook/dialog')({
  component: DialogRedirectPage,
});
